import type { ModalStep } from 'Features/SellerCommunications/services';
import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

import { ModalStepsToStageMap } from './consts';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

interface TriggerSellerMessagingVehicleRowClickedEventParams {
	enquiryId: string;
	step: ModalStep;
}

export const triggerSellerMessagingVehicleRowClickedEvent = ({
	enquiryId,
	step,
}: TriggerSellerMessagingVehicleRowClickedEventParams): void => {
	const label = { [enquiryId]: ModalStepsToStageMap[step] };
	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		customData: { label: JSON.stringify(label) },
		name: 'dlr_seller_messaging_vehicle_row_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
